import React from "react"

import A from '../A'
import styles from './Footer.module.scss'
import { BlurConsumer } from '../../context/blur'

import ExpandTop from './ExpandTop'

class Footer extends React.Component {
  render() {
    const { infos } = this.props;
    return (<BlurConsumer>
        {
          (context) => (<div
          className={this.props.variant === 'fixed' ? styles.variantfixed : ''}
          style={{
            marginBottom: '1.45rem',
          }}
        >
          <div
            className={styles.footerinner}
          >
            <p
              className={styles.footerCredits + " blurable " + (context.blur ? 'blur' : '')}
              >
                {''}
                GBR Systems&trade; è un branch operativo soggetto a controllo e
                coordinazione di&nbsp;
                <A
                  href="https://www.gbrdesign.com"
                  target="_blank"
                  style={{
                    fontSize: `12px`,
                    lineHeight: `18px`,
                  }}
                >
                  GBR Design&trade;
                </A>
            </p>
              <div className={styles.footerRightParent}>
              {
                /*
                <span onClick={() => this.toggleBlur()}>
                  <Language />
                </span>
                */
              /*<div
                style={{ marginLeft: 30, display: 'inline-block' }}
                className={"blurable " + (context.blur && context.item !== 'social' ? 'blur' : '')}
              >
                <ExpandTop
                  open={context.item === 'social'}
                  blurStart={() => context.toggle('social')}
                  socials={[
                    {
                      url: '',
                      text: 'Fb'
                    },
                    {
                      url: '',
                      text: 'Tw'
                    },
                    {
                      url: '',
                      text: 'Ln'
                    },
                    {
                      url: '',
                      text: 'Yt'
                    },
                  ]}
                  txt='socials'
                />
                </div>*/
              }
                <span
                  className={styles.linkInner}
                >P.IVA 09096540969</span>
              <div
                className={styles.footerRight + " blurable " + (context.blur && context.item !== 'info' ? 'blur' : '')}
              >
                <ExpandTop
                  width={130}
                  open={context.item === 'info'}
                  blurStart={() => context.toggle('info')}
                  socials={
                    infos ? infos.map( e => {
                      const node = e.node.entry
                      return {
                        url: `/it/` + node.Slug,
                        text: node.Title
                      }
                    }) : []
                  }
                  txt='Privacy e Cookie'
                />
              </div>
            </div>
          </div>
        </div>)}
    </BlurConsumer>)
  }
}
export default Footer
